function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var _ref2 = /*#__PURE__*/React.createElement("path", {
  d: "M18.3796 14.1948C18.6329 14.5236 18.3986 15 17.9835 15L12.5 15L7.01647 15C6.60144 15 6.36709 14.5236 6.6204 14.1948L7.02632 13.668L12.1403 8.37243C12.3369 8.16888 12.6631 8.16888 12.8597 8.37243L17.9737 13.668L18.3796 14.1948Z",
  fill: "currentColor"
});
function SvgDropdownArrowUp(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2);
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDropdownArrowUp);
export default __webpack_public_path__ + "static/media/DropdownArrowUp.739175c870983fff149e7d9d225e22f0.svg";
export { ForwardRef as ReactComponent };